import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoConfig, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styles: `
    .animation-open-menu {
       height: 310px;
    animation: frame-animation-open-menu 0.5s ease;
}

@keyframes frame-animation-open-menu {
  0% {
    height: 0px;
  }

  100% {
    height: 310px;
  }
}

  .animation-close-menu {
       height: 310px;
    animation: frame-animation-close-menu 0.6s ease;
}

@keyframes frame-animation-close-menu {
  0% {
    height: 310px !important;
  }

  100% {
    height: 0px;
  }
}
  `,
  standalone: false
})
export class MenuComponent implements OnInit {

  constructor(private route: Router, private transloco: TranslocoService) { }

  showMenu = false
  closeMenu = false
  showLang = false
  currentLangIcon = 0
  current: number = 0
  ngOnInit(): void {
    switch (this.transloco.getActiveLang()) {
      case 'it':
        this.currentLangIcon = 0
        break;
      case 'en':
        this.currentLangIcon = 1
        break;
      case 'de':
        this.currentLangIcon = 2
        break;
      case 'es':
        this.currentLangIcon = 3
        break;
      case 'fr':
        this.currentLangIcon = 4
        break;

      default:
        break;
    }
  }

  goTo(myRoute: string) {
    this.route.navigate([myRoute])
  }

  goToManger() {
    if (localStorage.getItem('token')) {
      this.route.navigate(['manager/profilo'])
    } else {
      this.route.navigate(['login'])
    }
  }

  changeLang(lang: string) {
    localStorage.setItem("language",JSON.stringify({value:lang}))
    this.transloco.setActiveLang(lang)
  }

  activateMenu() {
    if (this.showMenu) {
      this.closeMenu = true
      setTimeout(() => {
        this.showMenu = false
        this.closeMenu = false
      }, 499);
    } else {
      this.showMenu = true
    }
  }

}
